<template>
  <div>
    <!-------------Chat List------------------>
    <div class="box">
      <div
        class="ChartHeader cursor-pointer"
        @click="
          () => {
            chatHistoryBox = !chatHistoryBox;
          }
        "
      >
        <div class="">Messenger</div>        
        <div>
          <div
          class="badge badge-pill badge-danger"
          v-if="totalUnreadMessages > 0"
        >
          {{ totalUnreadMessages }}
        </div>
          <i
            @click="
              () => {
                startConservationDialog = true;
                chatHistoryBox = !chatHistoryBox;
              }
            "
            class="fas fa-plus mx-3"
          ></i>
        
          <i v-if="chatHistoryBox" class="fas fa-solid fa-chevron-down"></i>
          <i v-else class="fas fa-solid fa-chevron-up"></i>
        </div>
      </div>

      <div class="box-contant" v-if="chatHistoryBox">
        <div
          class="card flex justify-content-center"
          v-if="messageListLoading === true"
        >
          <ProgressSpinner aria-label="Messages ProgressSpinner" />
        </div>
        <div
          v-if="
            (inbox === null || inbox.length === 0) && chatHistoryBox === true
          "
        >
          <div
            class="d-flex justify-content-center"
            style="position: absolute; top: 32%; left: 32%"
          >
            <div
              class="d-flex flex-column justify-content-center bd-highlight mb-3"
            >
              <div class="p-2 bd-highlight">
                <img
                  src="/assets/images/veins logo.png"
                  width="100"
                  class="d-flex"
                />
              </div>
              <div class="p-2 bd-highlight">
                <i>No Messages</i>
              </div>
            </div>
          </div>
        </div>
        <div v-if="messageListLoading === false">
          <!-- <span v-if="!startConservationDialog">
            <div
              style="background:#D3D3D3"
              class="d-flex align-items-start px-3 py-3"
            >
              <i
                @click="
                  () => {
                    startConservationDialog = true;
                  }
                "
                style="margin-left: 0.7rem;font-size: 1.6rem;"
                class="fas fa-bars mr-2 cursor-pointer"
              ></i>
            </div>
          </span> -->
          <div v-if="!startConservationDialog">
            <div
              v-for="item in inbox"
              :key="item.chat_Id"
              class="list-group-item list-group-item-action border-tb cursor-pointer"
              @click="singleChat(item)"
            >
              <span>
                <div
                  style="margin-top: 0.7rem;"
                  :class="
                    item.taggedUserId > 0
                      ? 'badge badge-pill float-right badge-success'
                      : 'badge badge-pill float-right badge-light'
                  "
                  v-if="item.unreadMessageCount > 0"
                >
                  {{ item.unreadMessageCount }}
                </div>
                <div class="d-flex align-items-start">
                  <img
                    src="/assets/images/icons8-customer-128.png"
                    class="rounded-circle mr-1"
                    style="background-color: lightgray !important;"
                    alt="Avator Image"
                    width="40"
                    height="40"
                  />
                  <div class="flex-grow-1 ml-3 align-self-center">
                    <span v-if="item.chat_Name !== null">
                      {{ item.chat_Name }}
                    </span>
                    <span v-else>
                      {{
                        item.participants.find((x) => x.userId !== sendByUserId)
                          .firstName
                      }}
                      {{
                        item.participants.find((x) => x.userId !== sendByUserId)
                          .lastName
                      }}
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </div>
          <!--------- New Chat Section--------------------->
          <div v-if="startConservationDialog">
            <div
              class="list-group-item list-group-item-action cursor-pointer border-tb
                    "
            >
              <span @click="createGroup">
                <div class="d-flex align-items-start">
                  <div class="flex-grow-1 align-self-center">
                    <img
                      src="/assets/images/icons8-user-groups-128.png
                          "
                      class="rounded-circle mr-1"
                      style="background-color: lightgray !important;"
                      alt="Avator Image"
                      width="40"
                      height="40"
                    /><span class="ml-3">Create Group Chat</span>
                  </div>
                </div>
              </span>
            </div>
            <div
              @click="
                () => {
                  startConservationDialog = !startConservationDialog;
                  chatHistoryBox = true;
                }
              "
              class="d-flex align-items-center  cursor-pointer list-group-item border-tb py-4"
            >
              <div class="d-flex " role="button">
                <i class="fa fa-arrow-left"></i>
              </div>
              <div class="d-flex ml-5  startNewConservationHeading">
                Start New Conservation
              </div>
            </div>
            <div
              href="#"
              v-for="item in users"
              :key="item.id"
              class="list-group-item cursor-pointer list-group-item-action border-tb"
            >
              <span @click="singleNewChat(item)">
                <div class="d-flex align-items-start">
                  <img
                    src="/assets/images/icons8-customer-128.png"
                    class="rounded-circle mr-1"
                    style="background-color: lightgray !important;"
                    alt="Avator Image"
                    width="40"
                    height="40"
                  />
                  <div class="flex-grow-1 ml-3 align-self-center">
                    {{ item.firstName }} {{ item.lastName }}
                    <div class="small">
                      {{ item.email }}
                    </div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!------------------------------------------------>
    </div>
    <!-------------Individual Chat---------------------->
    <div
      class="box1"
      v-for="(item, i) in UpdateChatData"
      :key="i"
      :style="{ right: getRight(i) }"
    >
      <div
        v-if="item.IsDeleted === 0"
        class="box-contant  "
        style="padding:0"
        :style="!item.IsDisabled ? 'height: 3rem;border: none;' : ''"
      >
        <div style="position: relative;height:100%">
          <div
            class="MessageBox"
            style="height: 100%;"
            :style="!item.IsDisabled ? 'position: relative;width: 20rem;' : ''"
          >
            <div
              class="header cursor-pointer"
              :style="
                !item.IsDisabled
                  ? '    width: 103%;height: 3rem;overflow: hidden;border: 1px solid rgb(0 0 0 / 75%);border-bottom: 0 !important;position: absolute;bottom: 0;'
                  : ''
              "
            >
              <div class="row">
                <div class="col-11" @click="hideSingleChat(item)">
                  <h4 class="m-0" v-if="GroupName !== null">
                    {{ GroupName }} {{item.unreadMessageCount}}
                  </h4>
                  <h4 class="m-0" v-if="chat_Id == null && GroupName == null">
                    {{ item.firstName }} {{ item.lastName }} <div
                    class="badge badge-pill badge-danger float-right"
                    v-if="singleUnreadMessageCount > 0"
                  >
                    {{ singleUnreadMessageCount }}
                  </div>
                  </h4>
                </div>
                <div class="col-1">
                  <i
                    @click="DeleteSinleChatFromArray(item)"
                    class="fas fa-times cursor-pointer"
                  ></i>
                </div>
              </div>
            </div>
            <div class="body" v-if="item.IsDisabled" ref="chatMessages">
              <div style="width: 100%;overflow: hidden;">
                <div
                  class="card flex justify-content-center"
                  v-if="selectedChat !== null && messageLoading === true"
                >
                  <ProgressSpinner aria-label="Messages ProgressSpinner" />
                </div>
                <div v-if="messageLoading === false">
                  <span v-for="(value, key) in messages" :key="key">
                    <div
                      class="d-flex flex justify-content-center p-2"
                      v-if="value.message_Type === 0"
                    >
                      <div class="d-flex align-items-center flex-column">
                        <i class="text-muted small">{{ value.message_Text }}</i>
                        <i class="text-muted small">{{
                          new Date(value.timestamp).toLocaleDateString()
                        }}</i>
                        <i class="text-muted small">{{
                          convertUTCTimeToLocal(value.timestamp)
                        }}</i>
                      </div>
                    </div>
                    <template
                      v-if="
                        isDifferentDate(
                          value.timestamp,
                          messages[key - 1]?.timestamp
                        )
                      "
                    >
                      <!-- Display label for Today -->
                      <div
                        class="d-flex flex justify-content-center p-2"
                        v-if="isToday(value.timestamp)"
                      >
                        <Tag severity="info" value="Today" rounded></Tag>
                      </div>
                      <!-- Display label for Yesterday -->
                      <div
                        class="d-flex flex justify-content-center p-2"
                        v-else-if="isYesterday(value.timestamp)"
                      >
                        <Tag severity="info" value="Yesterday" rounded></Tag>
                      </div>
                      <!-- Display label for Older dates -->
                      <div
                        class="d-flex flex justify-content-center p-2"
                        v-else
                      >
                        <Tag
                          severity="info"
                          :value="
                            new Date(value.timestamp).toLocaleDateString()
                          "
                          rounded
                        ></Tag>
                      </div>
                    </template>
                    <div class="d-flex" v-if="value.message_Type !== 0">
                      <div
                        class="d-flex justify-content-between"
                        style="width: 100%"
                      >
                        <div>
                          <small
                            class=" mb-1"
                            v-if="
                              value.sender_Id !== sendByUserId &&
                                value.message_Type !== 0
                            "
                          >
                            <b>{{ value.senderName }}</b>
                          </small>
                          <small v-else>
                            <b>You</b>
                          </small>
                        </div>

                        <div>
                          <div class="text-muted small text-nowrap mt-1">
                            {{ convertUTCTimeToLocal(value.timestamp) }}
                          </div>
                          <!-- <div class="text-muted small text-nowrap mt-1">
                            {{ new Date(value.timestamp).toLocaleDateString() }}
                          </div> -->
                        </div>
                      </div>
                    </div>

                    <!-- Render Chat -->
                    <div
                      v-if="
                        value.sender_Id === sendByUserId &&
                          value.message_Type !== 0
                      "
                      class="chat-message-left pb-4"
                    >
                      <div
                        class="flex-shrink-1 rounded py-2 mt-2 px-2"
                        style="background: #12b0e859;"
                      >
                        <span v-if="value.message_Type === 1">{{
                          value.message_Text
                        }}</span>
                        <span v-if="value.message_Type === 2">
                          <img
                            :src="value.message_Text"
                            style="width:100%"
                            class="imgVideoSize"
                          />
                        </span>
                        <span v-if="value.message_Type === 3">
                          <a :href="value.message_Text" target="_blank" download
                            ><div class="card">
                              <div class="card-body d-block text-center">
                                <i
                                  class="fas fa-file-download downloadFileIcon"
                                ></i>
                                <p class="mb-0 pt-2">Download File</p>
                              </div>
                            </div></a
                          >
                        </span>
                        <span v-if="value.message_Type === 4">
                          <video
                            controls
                            class="imgVideoSize"
                            style="width:100%"
                          >
                            <source
                              :src="value.message_Text"
                              :type="getMediaType(value.message_Text, video)"
                            />
                            Your browser does not support the video tag.
                          </video>
                        </span>
                        <span v-if="value.message_Type === 5">
                          <audio controls style="width:100%">
                            <source
                              :src="value.message_Text"
                              :type="getMediaType(value.message_Text, audio)"
                            />
                            Your browser does not support the audio element.
                          </audio>
                        </span>
                      </div>
                    </div>

                    <div
                      class=" chat-message-right pb-4"
                      v-else-if="
                        value.sender_Id !== sendByUserId &&
                          value.message_Type !== 0
                      "
                    >
                      <div
                        class="flex-shrink-1 mt-2 bg-light rounded py-2 pl-2"
                      >
                        <span v-if="value.message_Type === 1">{{
                          value.message_Text
                        }}</span>
                        <span v-if="value.message_Type === 2">
                          <img :src="value.message_Text" class="imgVideoSize" />
                        </span>
                        <span v-if="value.message_Type === 3">
                          <a :href="value.message_Text" target="_blank" download
                            ><div class="card">
                              <div class="card-body d-block text-center">
                                <i
                                  class="fas fa-file-download downloadFileIcon"
                                ></i>
                                <p class="mb-0 pt-2">Download File</p>
                              </div>
                            </div></a
                          >
                        </span>
                        <span v-if="value.message_Type === 4">
                          <video
                            controls
                            class="imgVideoSize"
                            style="width:97.5%"
                          >
                            <source
                              :src="value.message_Text"
                              :type="getMediaType(value.message_Text, video)"
                            />
                            Your browser does not support the video tag.
                          </video>
                        </span>
                        <span v-if="value.message_Type === 5">
                          <audio controls style="width:96.5%">
                            <source
                              :src="value.message_Text"
                              :type="getMediaType(value.message_Text, audio)"
                            />
                            Your browser does not support the audio element.
                          </audio>
                        </span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div v-if="item.IsDisabled" class="footer">
              <OverlayPanel ref="taggedList">
                <Listbox
                  v-model="taggedUser"
                  @click="() => taggedMember()"
                  :options="taggingUsers"
                  optionLabel="firstName"
                  class="w-full md:w-14rem"
                  listStyle="max-height:250px"
                  ><template #option="slotProps">
                    <div>
                      {{ slotProps.option.firstName }}
                      {{ slotProps.option.lastName }} -
                      {{ slotProps.option.email }}
                    </div>
                  </template></Listbox
                >
              </OverlayPanel>
              <div class="flex-grow-0 sendMessageBar">
                <div class="d-flex align-items-center">
                  <button
                    type="button"
                    class="btn"
                    style="padding-top: 0.8rem;"
                  >
                    <div class="image-upload">
                      <label for="file-input">
                        <i class="fas fa-paperclip"></i>
                      </label>

                      <input
                        id="file-input"
                        @change="(event) => uploadChatFile(event, selectedChat)"
                        type="file"
                        accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .txt, .csv, .xlsx, .pptx, .mp4, .avi, .mkv, .mov, .webm, .mp3, .wav, .ogg, .flac"
                        style="display: none;border:none"
                      />
                    </div>
                  </button>
                  <button
                    type="button"
                    style="padding: 0;"
                    class="btn"
                    @click="toggle"
                  >
                    <i class="far fa-smile"></i>
                  </button>
                  <OverlayPanel ref="op"
                    ><Emoji
                      @emoji_click="addEmoji"
                      @click="handleEmojiClick(event)"
                    ></Emoji
                  ></OverlayPanel>

                  <textarea
                    class="form-control"
                    v-model="inputMessage"
                    rows="1"
                    cols="30"
                    style="border:none"
                    @keyup.enter="
                      selectedChat !== null ? addMessage(selectedChat) : ''
                    "
                    @keydown="(event) => showMembersTag(event)"
                    placeholder="Type Message..."
                  ></textarea>

                  <button
                    type="button"
                    class="btn"
                    @click="
                      selectedChat !== null ? addMessage(selectedChat) : ''
                    "
                  >
                    <i style="color:#007FAD" class="fas fa-paper-plane"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Create Group -->
    <Dialog
      v-model:visible="visible"
      modal
      :header="newGroup === true ? 'Create Group' : ''"
      :style="{ width: '500px' }"
    >
      <div class="row">
        <div class="col-12" v-if="newGroup === true">
          <InputText
            v-model="group.CHATNAME"
            class="my-2 w-100"
            type="1"
            placeholder="Group Name"
          />
        </div>
        <div class="col-12">
          <MultiSelect
            v-model="group.participants"
            :options="users"
            filter
            display="chip"
            optionLabel="firstName"
            placeholder="Select Users"
            :maxSelectedLabels="3"
            class="my-2 w-100"
          >
            <template #option="slotProps">
              <div class="flex align-items-center">
                <div>
                  {{ slotProps.option.firstName }}
                  {{ slotProps.option.lastName }} -
                  {{ slotProps.option.email }}
                </div>
              </div>
            </template>
          </MultiSelect>
        </div>
        <div class="col-12">
          <div class="d-flex justify-content-end my-2">
            <button
              v-if="newGroup === true"
              type="button"
              @click="saveGroup"
              class="btn btn-success ml-3"
            >
              Save
            </button>
            <button
              v-else
              type="button"
              @click="addNewParticipants"
              class="btn btn-success ml-3"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Emoji from "../components/Emoji-Picker/EmojiPicker.vue";
import { mapGetters } from "vuex";
import { HubConnectionBuilder } from "@microsoft/signalr";
export default {
  name: "UserChatPopUp",
  components: {
    Emoji,
  },
  data() {
    return {
      connection:{},
      singleUnreadMessageCount:0,
      totalUnreadMessages:0,
      startConservationDialog: false,
      messageListLoading: true,
      messageLoading: true,
      isEmoji: false,
      inputMessage: null,
      chatHistoryBox: false,
      singleChatData: [],
      AllChatData: [],
      UpdateChatData: [],
      inbox: null,
      users: null,
      messages: null,
      selectedChatId: 0,
      sendByUserId: 0,
      selectedChat: null,
      loggedInUser: null,
      enableTagging: false,
      lastDisplayedDate: null,
      taggingUsers: null,
      showMembers: false,
      members: null,
      taggedUser: null,
      taggedUsers: [],
      GroupName: "",
      messageTypeEnums: {
        System: 0,
        Text: 1,
        Image: 2,
        File: 3,
        Video: 4,
        Audio: 5,
      },
      chatModal: {
        chatId: 0,
        CHATTYPE: 0,
        CHATNAME: null,
        participants: null,
        senderId: 0,
        receiverId: 0,
        messageText: null,
        messageType: 1,
        timestamp: new Date(),
        file: null,
        taggedUserId: null,
      },

      isGroup: false,
      isSingle: false,
      group: {
        chatId: 0,
        CHATTYPE: 2,
        CHATNAME: "",
        senderId: this.sendByUserId,
        participants: null,
        receiverId: 0,
        messageText: "",
        messageType: 1,
        timestamp: new Date(),
        file: null,
        adminId: 0,
        taggedUserId: null,
      },
      visible: false,
      newGroup: false,
    };
  },

  methods: {
    createGroup() {
      this.visible = !this.visible;
      this.newGroup = true;
      this.getUsers();
      this.messages = null;
    },
    addNewParticipants() {
      var payload = {
        chatId: this.selectedChatId,
        participants: this.group.participants,
      };
      this.addParticipants(payload).then(() => {
        this.visible = false;

        var text = this.loggedInUser.firstName + " added ";
        this.group.participants.forEach((value, index, array) => {
          text += value.firstName;
          if (index !== array.length - 1) {
            text += ", ";
          }
        });
        this.inputMessage = text;
        this.group.messageType = 0;
        this.group.adminId = this.loggedInUser.userId;
        this.group.participants = null;
        this.group.senderId = this.sendByUserId;
        this.group.messageText = this.inputMessage;
        this.group.chatId = this.selectedChatId;
        this.visible = false;

        this.addMessage(this.group);
        this.messages = null;
      });
    },
    saveGroup() {
      this.startConservationDialog = false;
      var text = this.loggedInUser.firstName + " added ";
      this.group.participants.forEach((value, index, array) => {
        text += value.firstName;
        if (index !== array.length - 1) {
          text += ", ";
        }
      });
      this.inputMessage = text;
      this.group.messageType = 0;
      this.group.adminId = this.loggedInUser.userId;
      this.group.chatId = 0;

      this.isGroup = true;
      this.messages = null;
      this.group.participants.push(this.loggedInUser);
      this.visible = false;
      this.selectedChat = this.group;
      this.messageLoading = false;

      this.addMessage(this.group);
      this.isGroup = false;
      this.messages = null;
    },

    addMessage(item) {
      this.isEmoji = false;
      if (this.isGroup == true) {
        this.group.messageText = this.inputMessage;
        this.group.senderId = this.sendByUserId;
        this.inputMessage = null;
        this.adminId = this.loggedInUser.userId;
        this.taggedUserId = this.taggedUsers;

        Object.keys(this.group.participants).forEach((key) => {
          if (this.group.participants[key] == null) {
            delete this.group.participants[key];
          }
        });

        this.sendMessage(this.group).then((res) => {
          this.selectedChat.chat_Id = this.getChatId;
          this.selectedChat.chat_Type = 2;
          this.selectedChat.messageType = 1;
          this.selectedChat.messageText = "";
        });
        this.group = {
          chatId: 0,
          CHATTYPE: 2,
          CHATNAME: "",
          senderId: this.sendByUserId,
          participants: null,
          receiverId: 0,
          messageText: "",
          messageType: 1,
          timestamp: new Date(),
          file: null,
          adminId: 0,
          taggedUserId: null,
        };
        this.isGroup == false;
      } else if (this.isSingle == true) {
        var payload = this.selectedChat;
        payload.messageText = this.inputMessage;
        payload.adminId = 0;
        payload.taggedUserId = this.taggedUsers;
        this.inputMessage = null;
        this.sendMessage(payload);
        this.isSingle = false;
      } else if (
        this.isGroup == false &&
        item.messageType == 0 &&
        item.CHATTYPE == 2
      ) {
        this.inputMessage = null;
        this.sendMessage(item);
      } else {
        payload = {
          chatId: item.chat_Id,
          CHATTYPE: item.chat_Type,
          CHATNAME: item.chat_Name,
          participants: null,
          senderId: this.sendByUserId,
          taggedUserId: this.taggedUsers,
          receiverId: item.participants.find(
            (x) => x.userId !== this.sendByUserId
          ).userId,
          messageText: this.inputMessage,
          timestamp: new Date(),
          file: null,
          messageType: 1,
          adminId: 0,
        };
        this.inputMessage = null;
        this.sendMessage(payload);
      }
    },
    uploadChatFile(event, item) {
      var file = event.target.files[0];

      var payload = {
        chatId: item.chat_Id,
        CHATTYPE: item.chat_Type,
        CHATNAME: item.chat_Name,
        participants: null,
        senderId: this.sendByUserId,
        receiverId: item.participants.find(
          (x) => x.userId !== this.sendByUserId
        ).userId,
        messageText: this.inputMessage,
        timestamp: new Date(),
        file: file,
        messageType: 2,
        adminId: 0,
      };
      this.inputMessage = null;
      this.sendMessage(payload);
    },
    async sendMessage(payload) {
      if (payload.file) {
        const getType = this.getFileType(payload.file.name);
        payload.messageText = URL.createObjectURL(payload.file);
        payload.messageType = getType;
      }

      var chatModel = {
        chat_Id: payload.chatId,
        message_Id: 0,
        message_Text: payload.messageText,
        message_Type: payload.messageType,
        sender_Id: payload.senderId,
        senderName: "",
        receiver_Id: payload.receiverId,
        timestamp: new Date().toISOString(),
      };

      if (this.messages === null || this.messages === undefined) {
        // If messages is null or undefined, create a new array and push chatModel
        this.messages = [chatModel];
      } else {
        // If messages is not null or undefined, push chatModel to the existing array
        this.messages.push(chatModel);
      }

      this.$nextTick(() => {
        this.scrollToElement();
      });

      this.dummyComm.auditFlagVal = localStorage.OSversion;

      var payloadModel = { dummyComm: this.dummyComm, ...payload };

      await this.$store
        .dispatch("sendMessage", payloadModel)
        .then((response) => {
          if (
            this.selectedChat !== null &&
            this.messages !== null &&
            this.selectedChatId === this.getChatId
          ) {
            this.selectedChatId = this.getChatId;
            this.scrollToElement();
          } else {
            this.getAllMessages(this.getChatId).then(() => {
              this.selectedChatId = this.getChatId;
              this.scrollToElement();
            });
          }

          this.getUserInbox();

          return true;
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    showMembersTag(event) {
      // Check for Shift + @ key combination (Shift: 16, @: 50)
      if (event.shiftKey && event.keyCode === 50) {
        this.enableTagging = true;
        this.taggingUsers = this.selectedChat.participants;
        this.$refs.taggedList.toggle(event);
      } else if (this.enableTagging === true) {
        const ignoredKeyCodes = [
          16,
          17,
          18,
          13,
          27,
          9,
          32,
          37,
          38,
          39,
          40,
          112,
          113,
          114,
          115,
          116,
          117,
          118,
          119,
          120,
          121,
          122,
          123,
        ];

        if (ignoredKeyCodes.includes(event.keyCode)) {
          // Ignore the key press
          return;
        } else if (event.keyCode === 8) {
          this.taggingUsers = this.selectedChat.participants;
        } else {
          this.taggingUsers = this.taggingUsers.filter((participant) => {
            const searchTerm = event.key.toLowerCase();
            const firstNameMatch = participant.firstName
              .toLowerCase()
              .includes(searchTerm);
            const lastNameMatch = participant.lastName
              .toLowerCase()
              .includes(searchTerm);
            const emailMatch = participant.email
              .toLowerCase()
              .includes(searchTerm);

            return firstNameMatch || lastNameMatch || emailMatch;
          });
        }
      }
    },
    taggedMember() {
      if (this.inputMessage === null) {
        this.inputMessage = this.taggedUser.firstName;
      } else {
        const parts = this.inputMessage.split("@");
        const modifiedString = parts.slice(0, parts.length - 1).join("@");
        this.inputMessage = modifiedString + this.taggedUser.firstName;
      }
      this.taggedUsers.push(this.taggedUser.userId);
      this.enableTagging = false;
      this.taggingUsers = null;
      this.$refs.taggedList.toggle(false);
    },
    getFileType(url) {
      const filename = url.split("/").pop();
      const extension = filename
        .split(".")
        .pop()
        .toLowerCase();

      if (
        extension === "jpg" ||
        extension === "jpeg" ||
        extension === "png" ||
        extension === "gif"
      ) {
        return this.messageTypeEnums.Image;
      } else if (
        extension === "pdf" ||
        extension === "doc" ||
        extension === "docx" ||
        extension === "txt" ||
        extension === "csv" ||
        extension === "xlsx" ||
        extension === "pptx"
      ) {
        return this.messageTypeEnums.File;
      } else if (
        extension === "mp4" ||
        extension === "avi" ||
        extension === ".mkv" ||
        extension === "mov" ||
        extension === "webm"
      ) {
        return this.messageTypeEnums.Video;
      } else if (
        extension === "mp3" ||
        extension === "wav" ||
        extension === "ogg" ||
        extension === "flac"
      ) {
        return this.messageTypeEnums.Audio;
      }
      return null;
    },
    convertUTCTimeToLocal(dateTime) {
      const utcTime = dateTime.includes("Z") ? dateTime : dateTime + "Z";
      return new Date(utcTime).toLocaleTimeString();
    },
    getMediaType(url, type) {
      const filename = url.split("/").pop();
      const extension = filename
        .split(".")
        .pop()
        .toLowerCase();

      if (type === "video") {
        return `video/${extension}`;
      } else if (type === "audio") {
        return `audio/${extension}`;
      }

      return null;
    },
    isDifferentDate(timestamp, prevTimestamp) {
      const currentDate = new Date(timestamp).getDate();
      const prevDate = prevTimestamp ? new Date(prevTimestamp).getDate() : null;
      return currentDate !== prevDate;
    },

    isToday(timestamp) {
      const currentDate = new Date();
      const messageDate = new Date(timestamp);
      return (
        currentDate.getFullYear() === messageDate.getFullYear() &&
        currentDate.getMonth() === messageDate.getMonth() &&
        currentDate.getDate() === messageDate.getDate()
      );
    },

    isYesterday(timestamp) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const messageDate = new Date(timestamp);
      return (
        yesterday.getFullYear() === messageDate.getFullYear() &&
        yesterday.getMonth() === messageDate.getMonth() &&
        yesterday.getDate() === messageDate.getDate()
      );
    },
    async getLoggedIdUserInfo() {
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      this.sendByUserId = parseInt(arr[0]);
      await this.$store
        .dispatch("getUserProfile", this.sendByUserId)
        .then(() => {
          this.loggedInUser = this.getloggedInUserProfile;
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    async getUserInbox() {
      this.dummyComm.auditFlagVal = localStorage.OSversion;
      await this.$store
        .dispatch("getUserInbox", this.dummyComm)
        .then(() => {
          this.inbox = this.getInbox;         
          $
          this.messageListLoading = false;
          console.log(this.inbox) 
          if(this.inbox!= undefined)
          {
            if(this.inbox.length > 0)
            {            
              this.totalUnreadMessages = this.inbox[this.inbox.length-1].totalUnreadMessages;
            }
          }

          if(this.UpdateChatData.length>0)
          {
            this.inbox.map((UserChatdata,index)=>{
              if(UserChatdata.chat_Id==this.UpdateChatData[0].chat_Id)
              {
                this.singleUnreadMessageCount = UserChatdata.unreadMessageCount;
              }
            });              
          }
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    async markAsReadChat(payload) {
      await this.$store
        .dispatch("markAsReadChat", payload)
        .then((response) => {
          this.getUserInbox();
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    addEmoji(emoji) {
      if (this.inputMessage === null) {
        this.inputMessage = emoji;
      } else {
        this.inputMessage += emoji;
      }
    },
    DeleteSinleChatFromArray(item) {
      for (let i = 0; i < this.UpdateChatData.length; i++) {
        if (this.UpdateChatData[i].userId === item.userId) {
          this.UpdateChatData.splice(i, 1);
          console.log(`Deleted item with userId: ${item.userId}`);
          console.log(this.singleChatData);
          i--;
          item.IsDeleted = 0;
          const indexInSingleChatData = this.singleChatData.findIndex(
            (chat) => chat.userId === item.userId
          );
          if (indexInSingleChatData !== -1) {
            this.singleChatData.splice(indexInSingleChatData, 1);
          }
        }
      }
    },
    getRight(index) {
      const width = ["23%", "41.5%", "60%"];
      return width[index % width.length];
    },
    hideSingleChat(item) {      
      item.IsDisabled = !item.IsDisabled;
      if( item.IsDisabled  == true)
      {   
        this.$nextTick(() => {
          this.scrollToElement();
        });       
      }
    },
    async getAllMessages(chatId) {
      this.messageLoading = true;
      if (this.messages === null) {
        this.messageLoading = true;
      }
      await this.$store
        .dispatch("getMessagesByChatId", chatId)
        .then(() => {
          this.messages = this.getMessages;
          this.messageLoading = false;
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    scrollToElement() {
      if(this.$refs.chatMessages!==null)
      {
        this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight;
      }
    },

    singleChat(item) {   
      this.messages = null;
      this.selectedChatId = item.chat_Id;
      this.selectedChat = item;
      if (item.chat_Id != null) {
        this.getAllMessages(item.chat_Id).finally(() => {
          this.scrollToElement();
        });
      }

      let newItem = item.participants[1];
      const isDuplicate = this.UpdateChatData.some((existingItem) => {
        return existingItem.userId === newItem.userId;
      });
      this.GroupName = item.chat_Name;
      if (!isDuplicate) {
        newItem.IsDisabled = true;
        newItem.IsDeleted = 0;
        this.singleChatData.unshift(newItem);
        this.UpdateChatData = this.singleChatData.slice(0, 1);
        this.messageLoading = false;
      } else {
        newItem.IsDisabled = true;
      }

      if (item.unreadMessageCount > 0) {
        this.singleUnreadMessageCount = item.unreadMessageCount;
        var payload = {
          userId: this.loggedInUser.userId,
          chatId: item.chat_Id,
        };

        this.markAsReadChat(payload);
      }
    },

    singleNewChat(item) {
      this.messages = null;
      this.selectedChat = null;

      var members = [
        {
          userId: this.sendByUserId,
        },
        {
          userId: item.userId,
          picURL: item.picURL,
          firstName: item.firstName,
          lastName: item.lastName,
        },
      ];

      var matchingChats = null;

      for (var j = 0; j < this.inbox.length; j++) {
        var participants = this.inbox[j].participants;
        if (this.inbox[j].chat_Type == 1) {
          if (
            (participants.length === 2 &&
              participants[0].userId === members[0].userId &&
              participants[1].userId === members[1].userId) ||
            (participants[0].userId === members[1].userId &&
              participants[1].userId === members[0].userId)
          ) {
            matchingChats = this.inbox[j];
            break;
          }
        }
      }

      if (matchingChats != null) {
        this.selectedChat = matchingChats;
        this.singleChat(this.selectedChat);
      } else {
        var copyModal = this.chatModal;
        copyModal.chatId = 0;
        copyModal.CHATTYPE = 1;
        copyModal.CHATNAME = null;
        copyModal.senderId = this.sendByUserId;
        copyModal.receiverId = item.userId;

        copyModal.participants = members;
        this.selectedChat = copyModal;
        this.singleChat(copyModal);
        this.isSingle = true;
        this.messages = null;
      }

      this.startConservationDialog = false;
    },
    
    async getUsers() {
      this.dummyComm.auditFlagVal = localStorage.OSversion;
      await this.$store
        .dispatch("getUsers", this.dummyComm)
        .then((response) => {
          this.users = this.getChatUsers;
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    reconnectToHubCheck(){
      setTimeout(() => {
      this.reconnectToHub()
    }, 90000);
    },
    reconnectToHub()//if connection drop create new Connection 
    {
      console.log(this.connection.state);
      if (this.connection.state === "Disconnected") {
        this.connectionToHub();       
      }
      this.reconnectToHubCheck();
    },
    connectionToHub() {
      this.connection = new HubConnectionBuilder()
        .withUrl(`${process.env.VUE_APP_SERVERSIDE_URL}chathub`)
        .withAutomaticReconnect([1,////this Actualy makes it robust will start to reconnect
          1000,
          5000,
          10000,
          1100,
          12000,
          13000,
          14000,
          15000,
          16000,
          17000,
          18000,
          19000,
          20000,
          21000,
          22000,
          23000,
          24000,
          25000,
          26000,
          27000,
          28000,
          29000,
          30000,
          31000,
          32000,
          33000,
          34000,
          35000,])
        .build();
      // Start the SignalR connection
      this.connection
        .start()
        .then(() => {
          // Connection is successfully established
          this.connection.on("ReceiveMessage", (res) => {
            if (
              this.selectedChat !== null &&
              this.messages !== null &&
              this.selectedChatId === res.chat_Id
            ) {
              if (res.sender_Id !== this.sendByUserId) {
                if (this.messages === null || this.messages === undefined) {
                  // If messages is null or undefined, create a new array and push chatModel
                  this.messages = [res];
                } else {
                  // If messages is not null or undefined, push chatModel to the existing array
                  this.messages.push(res);
                }
                this.$nextTick(() => {
                  this.scrollToElement();
                });
              }

              this.getUserInbox();
            } else if (
              this.selectedChat !== null &&
              this.selectedChat.chatId === 0
            ) {
              var participants = this.selectedChat.participants;
              this.selectedChat = res;
              this.selectedChat = {
                participants: participants,
                ...this.selectedChat,
              };
              this.selectedChatId = res.chat_Id;
              this.getUserInbox();
            } else {
              this.getUserInbox();
            }
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  beforeMount() {
    this.getUsers();
    this.getUserInbox();
    this.getLoggedIdUserInfo();
  },
  mounted() {
    this.AllChatData = this.getChatUsers;
    this.DeleteSinleChatFromArray();
    this.connectionToHub();
    this.reconnectToHub();
  },
  onMounted() {
    //connection.stop();
  },
  computed: {
    ...mapGetters([
      "getChatUsers",
      "getProfileImage",
      "getInbox",
      "getMessages",
      "getLastMessage",
      "getChatId",
      "getloggedInUserProfile",
    ]),
  },
};
</script>
<style lang="scss" scoped>
.emoji-container {
  display: inline-block;
  position: absolute;
  z-index: 100;
  left: -115px;
  top: -305px;
}
.cursor-pointer {
  cursor: pointer;
}
.ChartHeader {
  color: white;
  width: 100%;
  height: 3rem;
  border: 1px solid rgba(0, 0, 0, 0.28);
  background: #007fad;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  padding: 0 1rem;
  justify-content: space-between;
}

.btn-button {
  border: none;
  :hover {
    background-color: lightgray;
  }
}

.box {
  width: 17.5%;
  position: fixed;
  bottom: 0%;
  z-index: 1000;
  right: 5%;
  padding-bottom: 0;
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .box-contant {
    //height: 500px;
    height: 32.4rem;
    overflow-y: scroll;
    background-color: white;
  }
}

.box1 {
  display: flex;
  position: fixed;
  //width: min-content;
  width: 21rem;
  bottom: 0%;
  z-index: 1000;
  flex-direction: row-reverse;
  //right: 22.45%;
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .box-contant {
    background: white;
    border: 1px solid #d9cdcd;
    overflow-x: hidden;
    height: 27rem;
    margin: 0 1%;
    width: 100%;
    .MessageBox {
      height: 100%;
      .header {
        background: #007fad;
        height: 10%;
        padding: 0 1rem;
        color: white;
        padding-top: 0.6rem;
      }
      .body {
        height: 77%;
        padding: 1rem;
        overflow-x: hidden;
        overflow-y: scroll;
      }
      .footer {
        border-top: 1px solid #e6e6e6;
        //height: 12%;
        margin: 0;
        padding: 0 0 0 0 !important;
      }
    }
  }
}
</style>
